export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const FORM_INPUT_CHANGE = 'FORM_INPUT_CHANGE';
export const FORM_INPUT_CHANGE_MULTIPLE = 'FORM_INPUT_CHANGE_MULTIPLE';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const PATIENT_FORM_DETAILS = 'PATIENT_FORM_DETAILS';
export const PATIENT_FORM_DETAILS_SUCCESS = 'PATIENT_FORM_DETAILS_SUCCESS';
export const PATIENT_FORM_DETAILS_FAILURE = 'PATIENT_FORM_DETAILS_FAILURE';
export const GET_PATIENTS = 'GET_PATIENTS';
export const GET_PATIENTS_SUCCESS = 'GET_PATIENTS_SUCCESS';
export const GET_PATIENTS_FAILURE = 'GET_PATIENTS_FAILURE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const GET_PATIENT = 'GET_PATIENT';
export const GET_PATIENT_SUCCESS = 'GET_PATIENT_SUCCESS';
export const GET_PATIENT_FAILURE = 'GET_PATIENT_FAILURE';
export const GET_PERFORMAONE = 'GET_PERFORMAONE';
export const GET_PERFORMAONE_SUCCESS = 'GET_PERFORMAONE_SUCCESS';
export const GET_PERFORMAONE_FAILURE = 'GET_PERFORMAONE_FAILURE';
export const GET_SCANS = 'GET_SCANS';
export const GET_SCANS_SUCCESS = 'GET_SCANS_SUCCESS';
export const GET_SCANS_FAILURE = 'GET_SCANS_FAILURE';
export const GET_XRAY = 'GET_XRAY';
export const GET_XRAY_SUCCESS = 'GET_XRAY_SUCCESS';
export const GET_XRAY_FAILURE = 'GET_XRAY_FAILURE';
export const GET_DISORDER_ANS_TREATMENT = 'GET_DISORDER_ANS_TREATMENT';
export const GET_DISORDER_ANS_TREATMENT_SUCCESS = 'GET_DISORDER_ANS_TREATMENT_SUCCESS';
export const GET_DISORDER_ANS_TREATMENT_FAILURE = 'GET_DISORDER_ANS_TREATMENT_FAILURE';
export const GET_CLINICAL_FEATURE = 'GET_CLINICAL_FEATURE';
export const GET_CLINICAL_FEATURE_SUCCESS = 'GET_CLINICAL_FEATURE_SUCCESS';
export const GET_CLINICAL_FEATURE_FAILURE = 'GET_CLINICAL_FEATURE_FAILURE';
export const GET_INVESTIGATION = 'GET_INVESTIGATION';
export const GET_INVESTIGATION_SUCCESS = 'GET_INVESTIGATION_SUCCESS';
export const GET_INVESTIGATION_FAILURE = 'GET_INVESTIGATION_FAILURE';
export const GET_DEXA = 'GET_DEXA';
export const GET_DEXA_SUCCESS = 'GET_DEXA_SUCCESS';
export const GET_DEXA_FAILURE = 'GET_DEXA_FAILURE';
export const GET_DEXA1 = 'GET_DEXA1';
export const GET_DEXA1_SUCCESS = 'GET_DEXA1_SUCCESS';
export const GET_DEXA1_FAILURE = 'GET_DEXA1_FAILURE';
export const GET_DEXA3 = 'GET_DEXA1';
export const GET_DEXA3_SUCCESS = 'GET_DEXA3_SUCCESS';
export const GET_DEXA3_FAILURE = 'GET_DEXA3_FAILURE';
export const GET_HRPQCT = 'GET_HRPQCT';
export const GET_HRPQCT_SUCCESS = 'GET_HRPQCT_SUCCESS';
export const GET_HRPQCT_FAILURE = 'GET_HRPQCT_FAILURE';
export const RESET_XRAY_STATE = 'RESET_XRAY_STATE';
export const RESET_SCAN_STATE = 'RESET_SCAN_STATE';
export const RESET_PATIENT_STATE = 'RESET_PATIENT_STATE';
export const RESET_DISORDER_ANS_TREATMENT_STATE = 'RESET_DISORDER_ANS_TREATMENT_STATE';
export const RESET_GET_PERFORMAONE_STATE = 'RESET_GET_PERFORMAONE_STATE';
export const RESET_CLINICAL_FEATURE_STATE = 'RESET_CLINICAL_FEATURE_STATE';
export const RESET_INVESTIGATION_STATE = 'RESET_INVESTIGATION_STATE';
export const RESET_DEXA_STATE = 'RESET_DEXA_STATE';
export const RESET_DEXA1_STATE = 'RESET_DEXA1_STATE';
export const RESET_DEXA3_STATE = 'RESET_DEXA3_STATE';
